module.exports = __webpack_public_path__ + "img/inception1.dd36a158.png";